import { createStore } from 'vuex'

import authenticate from './modules/authenticate'
import cancelRequest from './modules/cancelRequest'
import client from './modules/client'
import compliance from './modules/compliance'
import datatable from './modules/datatable'
import exportRequest from './modules/export-request'
import fileUpload from './modules/file-upload'
import filter from './modules/filter'
import forgotPassword from './modules/forgotPassword'
import global from './modules/global'
import inactivity from './modules/inactivity'
import location from './modules/location'
import navigation from './modules/navigation'
import notification from './modules/notification'
import passwordReset from './modules/passwordReset'
import profile from './modules/profile'
import requests from './modules/request'
import requestFiles from './modules/request-files'
import requestVos from './modules/request-vos'
import requestActual from './modules/requestActual'
import vendors from './modules/vendor'
import signature from './modules/signature'
import stats from './modules/stats'
import translationFile from './modules/translationFile'
import user from './modules/user'
import vendorFiles from './modules/vendor-files'
import vendorAvailability from './modules/vendor-availability'
import vendorReminders from './modules/vendor-reminders'
import vendorPoConfirm from './modules/vendor-po-confirm'
import vendorComplianceDetails from './modules/vendorComplianceDetails'


//import other modules here.

const store = createStore({
	modules: {
		auth: authenticate,
		cancelRequest,
		client,
		compliance,
		datatable,
		exportRequest,
		fileUpload,
		filter,
		forgotPassword,
		global,
		inactivity,
		location,
		nav: navigation,
		notify: notification,
		passwordReset,
		profile,
		user,
		requests,
		requestFiles,
		requestActual,
		requestVos,
		vendors,
		vendorAvailability,
		vendorFiles,
		signature,
		stats,
		vendorReminders,
		vendorPoConfirm,
		translationFile,
		vendorComplianceDetails
	},
})

window.VueStore = store;
export default store;